define(["./monitoringModule", "json!./mbr.json"], function (monitoringModule, mbr) {

    "use strict";
    monitoringModule.service("mbrService", ["$http", "uploadService", "downloadBinary", "$translate", "$filter", "remoteExceptionHandler", "loadingService", function ($http, uploadService, downloadBinary, $translate, $filter, remoteExceptionHandler, loadingService) {

        return {
            transitionChangeStatus: transitionChangeStatus,
            createOccurrence: createOccurrence,
            addOccurrenceComment: addOccurrenceComment,
            addTransitionComment: addTransitionComment,
            updateCurrentDriver: updateCurrentDriver,
            importTransitionSpreadsheet: importTransitionSpreadsheet,
            downloadAllMonitorablesAttachments: downloadAllMonitorablesAttachments,
            getAttachmentsByInvoiceIds: getAttachmentsByInvoiceIds,

            //after monitorable refactoring routes
            finishMonitorables: finishMonitorables,
            finishMonitorablesAt: finishMonitorablesAt,
            cancelMonitorables: cancelMonitorables,

            //trackingMobileRoutes
            updateTrackingInfo: updateTrackingInfo,
            updateTrackingInfoAndStart: updateTrackingInfoAndStart,

            //republicação de monitoraveis e transição
            publishOccurrence: publishOccurrence,
            publishTransition: publishTransition,

            saveOccurrenceStatus: saveOccurrenceStatus,
            deleteOccurrenceStatus: deleteOccurrenceStatus,

            //sensorConfiguration creation routes
            createSpecificConfigurationForMonitorable: createSpecificConfigurationForMonitorable,
            createSensorConfiguration: createSensorConfiguration,

            //devicesHistory
            getDevicesHistory: getDevicesHistory,

            // uniqueTrackingMonitorable
            getUniqueTrackingMonitorable: getUniqueTrackingMonitorable
        };

        // Utilizar os métodos abaixo para evitar problemas de '//' no path.
        function httpGet(path, config) {
            return $http.get(sanitize(path), config || {});
        }

        function httpPost(path, payload, config) {
            return $http.post(sanitize(path), payload, config || {});
        }

        function httpDelete(path, config) {
            return $http.get(sanitize(path), config || {});
        }

        function httpCall(method, path, data, headers) {
            return $http({
                method: method, url: sanitize(path), data: data, headers: headers
            });
        }


        function importTransitionSpreadsheet(file) {
            return uploadService.post(sanitize(mbr.baseUrl + "/transition/import/transitions/"), file)
                .then(getData);
        }

        function finishMonitorables(monitorableIds) {
            return httpPost(getServiceUrl("monitorable") + "finishMonitorablesById", monitorableIds, {
                params: {
                    completionSource: "FrontEnd"
                }
            }).then(getData);
        }

        function finishMonitorablesAt(restFinalizeMonitorableDTOs) {
            return httpPost(getServiceUrl("monitorable") + "finishMonitorablesAtById", restFinalizeMonitorableDTOs )
                .then(getData);
        }

        function cancelMonitorables(monitorableIds) {
            return httpPost(getServiceUrl("monitorable") + "cancelMonitorablesByIds", monitorableIds, {
                params: {
                    completionSource: "FrontEnd"
                }
            }).then(getData);
        }

        function updateTrackingInfo(devicesByMonitorable) {
            return httpPost(getServiceUrl("track"), devicesByMonitorable).then(getData);
        }

        function updateTrackingInfoAndStart(devicesByMonitorable) {
            return httpPost(getServiceUrl("trackStart"), devicesByMonitorable).then(getData);
        }

        function getServiceUrl(service) {
            return mbr.baseUrl + mbr.services[service];
        }

        function updateCurrentDriver(monitorableId, driverId) {
            return httpPost(getServiceUrl("monitorable") + monitorableId + "/current-driver", driverId).then(getData);
        }

        function createOccurrence(occurrenceAndComment, files) {
            var data = new FormData();
            data.append("occurrence", new Blob([JSON.stringify(occurrenceAndComment)], {
                type: "application/json"
            }));
            if (files) {
                Array.prototype.forEach.call(files, function (file) {
                    let encodedFilename = encodeURIComponent(file.name);
                    data.append("attachments", file, encodedFilename);
                })
            }
            return httpCall("POST", getServiceUrl("occurrence") + "/create", data, {
                "Content-Type": undefined
            }).then(getData);
        }

        function transitionChangeStatus(data) {
            return httpCall("POST", getServiceUrl("transition") + "/finalize-comment", data, {
                "Content-Type": undefined
            }).then(getData);
        }

        function addTransitionComment(transitionId, content, fileList) {
            return addComment(null, transitionId, content, fileList, "transition");
        }

        function addOccurrenceComment(occurrenceId, content, newStatus, fileList) {
            return addComment(newStatus, occurrenceId, content, fileList, "occurrence");
        }

        function addComment(newStatus, entityId, content, fileList, serviceId) {
            if (!newStatus) {
                newStatus = {};
            }
            var data = new FormData();
            data.append("comment", new Blob([JSON.stringify({
                content: content
            })], {
                type: "application/json"
            }));
            data.append("status", new Blob([JSON.stringify(newStatus)], {
                type: "application/json"
            }));
            if (fileList) {
                Array.prototype.forEach.call(fileList, function (file) {
                    let encodedFilename = encodeURIComponent(file.name);
                    data.append("attachments", file, encodedFilename);
                })
            }
            return httpCall("POST", getServiceUrl(serviceId) + entityId + "/comment", data, {
                "Content-Type": undefined
            }).then(getData);
        }


        function getData(response) {
            return response.data;
        }

        function publishOccurrence(occurrenceId) {
            return httpGet(getServiceUrl("occurrence") + "publish-occurrence" + "/" + occurrenceId);
        }

        function publishTransition(transitionId) {
            return httpGet(getServiceUrl("transition") + "publish-transition" + "/" + transitionId);
        }

        function deleteOccurrenceStatus(id) {
            return httpDelete(getServiceUrl("occurrence") + "/status/delete/" + id).then(getData);
        }

        function saveOccurrenceStatus(occurrenceStatus) {
            return httpPost(getServiceUrl("occurrence") + "/status/save", occurrenceStatus).then(getData);
        }

        function createSpecificConfigurationForMonitorable(id, configs) {
            return httpPost(getServiceUrl("sensorConfiguration") + "/create/specific/" + id, configs).then(getData);
        }

        function createSensorConfiguration(sensors) {
            return httpPost(getServiceUrl("sensorConfiguration") + "/createOrDelete", sensors).then(getData);
        }

        function getDevicesHistory(monitorableId) {
            return httpGet(getServiceUrl("track") + "/devices-history",
     {
                headers: {id: monitorableId}
            }
            ).then(getData);
        }

        function getUniqueTrackingMonitorable(monitorableId) {
            return httpGet(getServiceUrl("track") + "/unique-tracking-monitorable",
                {
                    headers: {id: monitorableId}
                }
            ).then(getData);
        }

        function downloadAllMonitorablesAttachments(monitorableIds) {
            var dateFilter = $filter("date");
            return loadingService(downloadBinary.post(getServiceUrl("monitorable") + "downloadAllMonitorablesAttachments", monitorableIds, $translate.instant("monitoring.downloadAllMonitorableAttachments") + "-" + dateFilter(new Date(), "yyyy-MM-dd") + ".zip"))
                .catch(remoteExceptionHandler());
        }

        function getAttachmentsByInvoiceIds(monitorableIds) {
            return loadingService(httpPost(getServiceUrl("monitorable") + "getAttachmentsByInvoiceIds", monitorableIds)).catch(remoteExceptionHandler());
        }

        /**
         * Trata barras duplas
         * */
        function sanitize(path) {
            return path
                .replace("//", "/");
        }
    }]);
});
